import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import ContactInfoBar from "./components/ContactInfoBar";
import Footer from "./components/Footer";
import ScrollToTop from "./ScrollToTop";

export default function Layout() {
  const location = useLocation();
  const showContactInfoBar =
    location.pathname === "/" || location.pathname.startsWith("/our-team");

  const [navOpen, setNavOpen] = useState(false);

  return (
    <>
      {/* ───── Site Header / Navbar ───── */}
      <header className="bg-white text-blue-900 shadow-md fixed top-0 left-0 w-full z-50">
        <div className="w-full px-4 sm:px-6 flex items-center justify-between h-20 md:h-24">
     
          <Link to="/" className="flex items-center flex-shrink-0">
            <img
              src="/images/falconFinal.png"
              alt="Falcon Logo"
              className="h-60 sm:h-46 md:h-50 w-auto drop-shadow-lg cursor-pointer"
              style={{
                maxHeight: "200px",
                minHeight: "140px",
                filter: "contrast(140%) brightness(0.6) saturate(200%)",
              }}
            />
          </Link>

          {/* Center Title
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 text-xl lg:text-2xl font-bold tracking-wide whitespace-nowrap">
            FALCON LAW
          </div> */}

          {/* Hamburger Menu (Mobile) */}
          <div className="md:hidden ml-auto">
            <button
              className="p-2 focus:outline-none"
              onClick={() => setNavOpen(!navOpen)}
              aria-label="Toggle navigation"
            >
              <svg className="h-7 w-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={navOpen ? "M6 18L18 6M6 6l12 12" : "M4 8h16M4 16h16"}
                />
              </svg>
            </button>
          </div>

          {/* Nav Links */}
         <nav className={`flex-col md:flex-row md:flex space-y-4 md:space-y-0 md:space-x-8 font-garamond text-xl font-semibold absolute md:static top-24 left-0 w-full md:w-auto bg-white md:bg-transparent shadow-md md:shadow-none z-40 transition-all duration-200 ease-in-out
            ${navOpen ? "flex" : "hidden"} md:flex`}>
            <Link to="/" className="block px-4 py-2 hover:text-blue-700" onClick={() => setNavOpen(false)}>
              Home
            </Link>
            <Link to="/team" className="block px-4 py-2 hover:text-blue-700" onClick={() => setNavOpen(false)}>
              Our Team
            </Link>
            <Link to="/services" className="block px-4 py-2 hover:text-blue-700" onClick={() => setNavOpen(false)}>
              Our Services
            </Link>
            <Link to="/blog" className="hover:text-blue-700 px-4 py-2" onClick={() => setNavOpen(false)}>
              Blog
            </Link>
            <Link to="/contact" className="block px-4 py-2 hover:text-blue-700" onClick={() => setNavOpen(false)}>
              Contact
            </Link>
          </nav>
        </div>
        
      </header>

      {/* Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* ───── Page Content ───── */}
      <main className="pt-20 md:pt-24">
        <Outlet />
      </main>

      {/* ───── ContactInfoBar only on Home and Our Team (just above Footer) ───── */}
      {showContactInfoBar && <ContactInfoBar />}

      {/* ───── Footer ───── */}
      <Footer />
    </>
  );
}
